import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc49a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps-0" }
const _hoisted_2 = { class: "d-flex flex-column mb-5" }
const _hoisted_3 = { class: "texto mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "d-flex flex-column mb-5" }
const _hoisted_6 = { class: "texto mb-1" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = { class: "d-flex flex-column mb-5" }
const _hoisted_9 = { class: "texto mb-1" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = { class: "d-flex flex-column mb-5" }
const _hoisted_12 = { class: "texto mb-1" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "FilterLubrificantes",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: false,
    onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _createElementVNode("h6", _hoisted_3, [
            _createTextVNode(" Marca "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_select, {
            placeholder: "Marca",
            type: "text",
            clearable: "",
            filterable: "",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.marca,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsFilter.marca) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeLubrificantes, (marcaProd, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: marcaProd.nome,
                  value: marcaProd.id_marca_produto
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("h6", _hoisted_6, [
            _createTextVNode(" Viscosidade "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_input, {
            placeholder: "Viscosidade",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.viscosidade,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paramsFilter.viscosidade) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("h6", _hoisted_9, [
            _createTextVNode(" Produto "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_input, {
            placeholder: "Produto",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.produto,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paramsFilter.produto) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("h6", _hoisted_12, [
            _createTextVNode(" Tipo "),
            (_ctx.spanWarning == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " * "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.paramsFilter.tipo,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paramsFilter.tipo) = $event)),
            placeholder: "Selecione um tipo para pesquisa",
            clearable: "",
            style: {"border":"1px solid rgb(181, 181, 195)","border-radius":"5px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Semisintetico",
                value: "semisintetico"
              }),
              _createVNode(_component_el_option, {
                label: "Sintetico",
                value: "sintetico"
              }),
              _createVNode(_component_el_option, {
                label: "Mineral",
                value: "mineral"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}